import { Second } from 'web-utility';
import { KLine } from '../../../../model/canister/KLine';
import {
  Bar,
  LibrarySymbolInfo,
  SubscribeBarsCallback
} from '../../../../static/charting_library/charting_library.min';
import { IStreamProvider } from '../interface';
import { parseResolutionToTickSpaceIndex } from '../utils';

export class EX3StreamProvider implements IStreamProvider {
  private priceDecimals = 0;
  private baseTokenDecimals = 0;
  private klineCanisterId = '';
  private fetchLatestTickTimer?: NodeJS.Timer;

  constructor(
    klineCanisterId: string,
    priceDecimals: number,
    baseTokenDecimals: number
  ) {
    this.klineCanisterId = klineCanisterId;
    this.priceDecimals = priceDecimals;
    this.baseTokenDecimals = baseTokenDecimals;
  }

  subscribeBars(
    symbolInfo: LibrarySymbolInfo,
    resolution: string,
    onRealtimeCallback: SubscribeBarsCallback,
    listenerGuid: string,
    onResetCacheNeededCallback: () => void
  ): void {
    this.fetchLatestTickTimer = setInterval(async () => {
      const { priceDecimals, baseTokenDecimals } = this;
      const klineActor = new KLine(this.klineCanisterId);
      try {
        const tick = parseResolutionToTickSpaceIndex(resolution);
        const crtTick = await klineActor.fetchCurrentTick(tick);
        if (!crtTick) return;
        const newBar: Bar = {
          time: crtTick.time,
          volume: crtTick.volume.shiftedBy(-baseTokenDecimals).dp(2).toNumber(),
          close: crtTick.close.shiftedBy(-priceDecimals).toNumber(),
          open: crtTick.open.shiftedBy(-priceDecimals).toNumber(),
          high: crtTick.high.shiftedBy(-priceDecimals).toNumber(),
          low: crtTick.low.shiftedBy(-priceDecimals).toNumber()
        };
        console.debug(`crtTick ${newBar.time} lastPrice ${newBar.close}`);
        // TODO , update bar
        onRealtimeCallback(newBar);
      } catch (error) {
        console.error('stream currtntTick', error);
      }
    }, Second * 10);
  }

  unsubscribeBars(listenerGuid: string): void {
    if (this.fetchLatestTickTimer) {
      clearInterval(this.fetchLatestTickTimer);
      this.fetchLatestTickTimer = undefined;
    }
  }
}

// Take a single trade, and subscription record, return updated bar
const updateBar = (data, sub) => {
  var lastBar = sub.lastBar;
  let resolution = sub.resolution;
  if (resolution.includes('D')) {
    // 1 day in minutes === 1440
    resolution = 1440;
  } else if (resolution.includes('W')) {
    // 1 week in minutes === 10080
    resolution = 10080;
  }
  var coeff = resolution * 60;
  var rounded = Math.floor(data.time / coeff) * coeff;
  var lastBarSec = lastBar.time / 1000;
  var _lastBar;
  if (rounded > lastBarSec) {
    // create a new candle, use last close as open **PERSONAL CHOICE**
    _lastBar = {
      time: rounded * 1000,
      open: lastBar.close,
      high: lastBar.close,
      low: lastBar.close,
      close: data.price,
      volume: data.volume
    };
  } else {
    // update lastBar candle!
    if (data.price < lastBar.low) {
      lastBar.low = data.price;
    } else if (data.price > lastBar.high) {
      lastBar.high = data.price;
    }
    lastBar.volume += data.volume;
    lastBar.close = data.price;
    _lastBar = lastBar;
  }
  return _lastBar;
};
